import { parsePhoneNumber } from 'libphonenumber-js/max';
import { store } from '../../../../../resources/frontend/js/store/index';
import { dataLayerPush } from '../../../../../resources/frontend/js/mixins/v2.0.0/data-layer-push';

export const isRiskAcceptable = (riskLevel, maximumRisk) => {
    const riskLevels = ['low', 'medium', 'high'];
    const riskIndex = riskLevels.indexOf(riskLevel);
    const maxRiskIndex = riskLevels.indexOf(maximumRisk);

    if (riskIndex === -1) return false;

    return riskIndex <= maxRiskIndex;
};

export const validateEmailViaAbstractApi = async (name, email) => {
    if (!email) return true;

    try {
        const params = new URLSearchParams({ email });

        dataLayerPush('abstractapi.email_validation.request', { email });

        const response = await fetch(`/api/abstract-email-validation?${params}`);
        const result = await response.json();

        dataLayerPush('abstractapi.email_validation.response', {
            deliverable: result.deliverable,
            accepted: result.deliverable,
            abstract_api_data: result.raw,
        });

        if (!result.deliverable) {
            store.commit('form/setFieldData', { name, key: 'preValidate', value: false });
            store.commit('form/setFieldData', { name, key: 'validate', value: false });
            return false;
        }
    } catch (error) {
        dataLayerPush('abstractapi.email_validation.error', { error: error.message });
        console.error('[EmailValidation] API error:', error);
    }

    return true;
};

export const validatePhoneViaAbstractApi = async (name, phone) => {
    if (!phone) return true;

    try {
        const countryCode = store.state.page.countryCode;
        const parsed = parsePhoneNumber(phone, countryCode?.toUpperCase());
        const internationalPhone = parsed ? parsed.formatInternational() : phone;
        const params = new URLSearchParams({ phone: internationalPhone });
        if (countryCode) {
            params.append('country', countryCode);
        }

        dataLayerPush('abstractapi.phone_validation.request', { phone: internationalPhone });

        const response = await fetch(`/api/abstract-phone-validation?${params}`);
        const result = await response.json();

        const phoneValidation = store.state.form.phoneValidation;
        const isValid = result.valid && isRiskAcceptable(result.risk_level, phoneValidation.maximumRisk);

        dataLayerPush('abstractapi.phone_validation.response', {
            valid: result.valid,
            risk_level: result.risk_level,
            accepted: isValid,
            abstract_api_data: result.raw,
        });

        if (!isValid) {
            store.commit('form/setFieldData', { name, key: 'preValidate', value: false });
            store.commit('form/setFieldData', { name, key: 'validate', value: false });
            return false;
        }
    } catch (error) {
        dataLayerPush('abstractapi.phone_validation.error', { error: error.message });
        console.error('[PhoneValidation] API error:', error);
    }

    return true;
};

export const validateFieldsViaAbstractApi = async () => {
    const currentStep = store.state.form.attributes.step;
    const fields = store.state.form.fields[currentStep];

    for (const [name, field] of Object.entries(fields)) {
        if (field.dataType === 'Email' && store.state.form.emailValidation.enabled) {
            const isValid = await validateEmailViaAbstractApi(name, field.value);
            if (!isValid) return false;
        }

        if (field.dataType === 'PhoneNumber' && store.state.form.phoneValidation.enabled) {
            const isValid = await validatePhoneViaAbstractApi(name, field.value);
            if (!isValid) return false;
        }
    }

    return true;
};
